require('./assets/scss/app-register.scss');
require('./assets/js/app');